import { Menu } from "@mui/material";
import React from "react";
import { Brand } from "../../../../../explorer/types";
import { AppIconsBrands, AppIconsShieldFilled } from "../../../AppIcons";
import { MenuItemStyled, AppBrandMenuIcon } from "./AppBrandMenu.styles";
import useBrands from "../../../../../explorer/hooks/useBrands";
import useGoToPage from "../../../../hook/useGoToPage";
import { defaultBrand } from "../../../../configuration/defaultSettings";

export function AppBrandMenu() {
  const brands = useBrands().brands;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const goToPage = useGoToPage();
  const currentBrand = useBrands().currentBrand;

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    // evitiamo che si apra il menu fino a quando non ci saranno altri brand
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuCloseOnChange = (brand: Brand) => {
    goToPage.changeBrand(brand.code ?? defaultBrand);
    handleMenuClose();
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      className="AppBrandMenu-menu"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {brands.map((brand: Brand, index: number) => (
        <MenuItemStyled
          key={index}
          onClick={() => handleMenuCloseOnChange(brand)}
          className={brand.code?.toLocaleLowerCase() === currentBrand?.code?.toLocaleLowerCase() ? "selected" : ""}
        >
          <div>
            <AppIconsShieldFilled />
            <div>
              <span>{brand.descr}</span>
            </div>
          </div>
        </MenuItemStyled>
      ))}
    </Menu>
  );
  return (
    <React.Fragment>
      <AppBrandMenuIcon
        className="AppBrandMenu-icon"
        size="large"
        // edge="end"
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleMenuOpen}
        color="inherit"
        disabled={!brands || brands.length < 2}
      >
        <AppIconsBrands />
      </AppBrandMenuIcon>
      {renderMenu}
    </React.Fragment>
  );
}
